import { motion } from "framer-motion";
import type { ReactNode } from "react";

/** Shared page wrapper: route transition + navbar offset. */
export function PageShell({ children, testId }: { children: ReactNode; testId?: string }) {
  return (
    <motion.main
      data-testid={testId}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.28, ease: [0.16, 1, 0.3, 1] }}
      className="flex-1 pt-16"
    >
      {children}
    </motion.main>
  );
}
